import { PageIndicator } from './PageIndicator';
import { ScrollButton } from './ScrollButton';

interface Props {
  /** Total slide count. */
  count: number;
  /** Currently visible slide index. */
  activeIndex: number;
  /** Scroll the given slide index to the start of the track. */
  onScrollToIndex: (index: number) => void;
}

/**
 * Carousel navigation — prev/next scroll buttons + the page-dot indicator.
 * Presentational: the active index and the scroll action come from the carousel
 * ({@link useCarousel}); this just wires the two controls to them.
 */
export function CarouselNav({ count, activeIndex, onScrollToIndex }: Props) {
  return (
    <>
      <ScrollButton
        direction="left"
        disabled={activeIndex === 0}
        onClick={() => onScrollToIndex(activeIndex - 1)}
      />
      <ScrollButton
        direction="right"
        disabled={activeIndex >= count - 1}
        onClick={() => onScrollToIndex(activeIndex + 1)}
      />
      <PageIndicator count={count} active={activeIndex} />
    </>
  );
}
